/**
 * Service de sons via Web Audio API
 */

class SoundService {
  private ctx: AudioContext | null = null;
  private enabled = true;

  private getContext(): AudioContext | null {
    if (!this.ctx) {
      try {
        this.ctx = new AudioContext();
      } catch {
        return null;
      }
    }
    return this.ctx;
  }

  private playTone(
    frequency: number,
    duration: number,
    type: OscillatorType = 'sine',
    volume = 0.2,
    delay = 0
  ): void {
    if (!this.enabled) return;
    const ctx = this.getContext();
    if (!ctx) return;

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.type = type;
    osc.frequency.setValueAtTime(frequency, ctx.currentTime + delay);

    gain.gain.setValueAtTime(0, ctx.currentTime + delay);
    gain.gain.linearRampToValueAtTime(volume, ctx.currentTime + delay + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + duration);

    osc.start(ctx.currentTime + delay);
    osc.stop(ctx.currentTime + delay + duration + 0.05);
  }

  /** Son de déplacement du pion */
  move(): void {
    this.playTone(440, 0.08, 'sine', 0.15);
  }

  /** Son de placement de mur */
  wall(): void {
    this.playTone(200, 0.12, 'square', 0.1);
    this.playTone(180, 0.08, 'square', 0.08, 0.08);
  }

  /** Son de victoire */
  win(): void {
    this.playTone(523, 0.12, 'sine', 0.25);       // C5
    this.playTone(659, 0.12, 'sine', 0.25, 0.13); // E5
    this.playTone(784, 0.12, 'sine', 0.25, 0.26); // G5
    this.playTone(1047, 0.3, 'sine', 0.3, 0.39);  // C6
  }

  /** Son de défaite */
  lose(): void {
    this.playTone(392, 0.15, 'sine', 0.2);        // G4
    this.playTone(349, 0.15, 'sine', 0.2, 0.16);  // F4
    this.playTone(294, 0.3, 'sine', 0.2, 0.32);   // D4
  }

  /** Son de notification (tour adverse) */
  turnStart(): void {
    this.playTone(660, 0.06, 'sine', 0.1);
    this.playTone(880, 0.08, 'sine', 0.1, 0.08);
  }

  /** Son d'alerte (timer faible) */
  timerWarning(): void {
    this.playTone(880, 0.05, 'square', 0.08);
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  isEnabled(): boolean {
    return this.enabled;
  }
}

export const soundService = new SoundService();
